import * as i0 from '@angular/core';
import { inject, signal, computed, Injectable, input, effect, Component } from '@angular/core';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { Subject } from 'rxjs';
import { NgClass } from '@angular/common';
import { StatusLightSizesEnum, StatusLightColorsEnum, StatusLightBordersEnum, NgxStatusLightComponent } from '@digipay/ngx-status-light';
import { NgxIcon } from '@digipay/ngx-icon';
import { NgxTooltipDirective } from '@digipay/ngx-tooltip';
import * as i1 from '@digipay/ngx-badge';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import { NgxRouterLoadingDirective } from '@digipay/ngx-router-loading';
const _c0 = a0 => ({
  visible: a0
});
const _c1 = (a0, a1) => ({
  active: a0,
  attentive: a1
});
const _c2 = (a0, a1) => ({
  "text-onback-high": a0,
  "text-onback-brand": a1
});
const _c3 = (a0, a1) => ({
  "text-onback-medium": a0,
  "text-onback-brand": a1
});
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("click", function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_Conditional_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleBack());
    });
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelement(2, "ngx-icon", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵtext(4, "\u0628\u0627\u0632\u06AF\u0634\u062A");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "arrow-right")("iconSize", "24px")("type", "linear");
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "ngx-badge", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", ctx_r1.getBadgeType(item_r3.badge) === "count" ? "sm" : "btnBadge")("mode", "bold")("status", "error")("type", ctx_r1.getBadgeType(item_r3.badge));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3.badge);
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "ngx-status-light", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("isAbsolute", false)("showStatusLight", true)("statusSize", ctx_r1.StatusLightSizesEnum.TEN)("statusColor", item_r3.statusLight)("statusBorderColor", ctx_r1.StatusLightBordersEnum.WHITE);
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "ngx-badge", 14);
    i0.ɵɵelement(2, "ngx-icon", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", item_r3.iconBadge.badge.size)("status", item_r3.iconBadge.badge.status)("circularIcon", item_r3.iconBadge.badge.hasCircularIcon)("type", "icon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", item_r3.iconBadge.icon.name)("type", item_r3.iconBadge.icon.type)("iconSize", item_r3.iconBadge.icon.size)("secondaryColor", item_r3.iconBadge.icon.secondaryColor);
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_0_Conditional_1_Template, 3, 5, "div", 8)(2, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_0_Conditional_2_Template, 2, 5)(3, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_0_Conditional_3_Template, 3, 8);
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵelement(5, "ngx-icon", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngxTooltip", item_r3.tooltip)("tooltipPosition", "top")("tooltipType", "hover")("routerLink", item_r3.route)("ngClass", i0.ɵɵpureFunction2(12, _c1, item_r3.active, item_r3.attentive && !item_r3.active));
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, item_r3.badge ? 1 : item_r3.statusLight ? 2 : item_r3.iconBadge ? 3 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c2, !item_r3.active, item_r3.active));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", item_r3.icon)("iconSize", "24px")("type", item_r3.active ? "bold" : "linear");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(18, _c3, !item_r3.active, item_r3.active));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.title, " ");
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "ngx-badge", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", ctx_r1.getBadgeType(item_r3.badge) === "count" ? "sm" : "btnBadge")("mode", "bold")("status", "error")("type", ctx_r1.getBadgeType(item_r3.badge));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3.badge);
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "ngx-status-light", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("isAbsolute", false)("showStatusLight", true)("statusSize", ctx_r1.StatusLightSizesEnum.TEN)("statusColor", item_r3.statusLight)("statusBorderColor", ctx_r1.StatusLightBordersEnum.WHITE);
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "ngx-badge", 14);
    i0.ɵɵelement(2, "ngx-icon", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", item_r3.iconBadge.badge.size)("status", item_r3.iconBadge.badge.status)("circularIcon", item_r3.iconBadge.badge.hasCircularIcon)("type", "icon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", item_r3.iconBadge.icon.name)("type", item_r3.iconBadge.icon.type)("iconSize", item_r3.iconBadge.icon.size)("secondaryColor", item_r3.iconBadge.icon.secondaryColor);
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_1_Conditional_1_Template, 3, 5, "div", 8)(2, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_1_Conditional_2_Template, 2, 5)(3, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_1_Conditional_3_Template, 3, 8);
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵelement(5, "ngx-icon", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", item_r3.route)("ngClass", i0.ɵɵpureFunction2(9, _c1, item_r3.active, item_r3.attentive && !item_r3.active));
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, item_r3.badge ? 1 : item_r3.statusLight ? 2 : item_r3.iconBadge ? 3 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c2, !item_r3.active, item_r3.active));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", item_r3.icon)("iconSize", "24px")("type", item_r3.active ? "bold" : "linear");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c3, !item_r3.active, item_r3.active));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.title, " ");
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_0_Template, 8, 21, "div", 7)(1, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Conditional_1_Template, 8, 18);
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵconditional(0, item_r3.tooltip ? 0 : 1);
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_Conditional_1_Template, 5, 3, "div", 2);
    i0.ɵɵrepeaterCreate(2, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_For_3_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r1.returnMode() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.items());
  }
}
function NgxBottomNavigationWrapperComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxBottomNavigationWrapperComponent_Conditional_1_Conditional_0_Template, 4, 1, "div", 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(0, !ctx_r1.isLoading() ? 0 : -1);
  }
}
let NgxBottomNavigationService = /*#__PURE__*/(() => {
  class NgxBottomNavigationService {
    constructor() {
      this.router = inject(Router);
      this.isVisible = signal(false);
      this.isLoading = signal(false);
      this.returnMode = signal(false);
      this.automaticActivation = signal(true);
      this.reservedHeight = computed(() => {
        if (!this.isVisible()) {
          return 0;
        } else {
          return 20 + 64 + 10;
        }
      });
      this.items = signal([]);
      this.backSubject = new Subject();
      this.onBackClick = this.backSubject.asObservable();
      this.router.events.subscribe({
        next: event => {
          if (this.automaticActivation() && this.items().length) {
            if (event instanceof NavigationEnd) {
              this.findActiveItem();
            }
          }
        }
      });
    }
    show() {
      this.isVisible.set(true);
    }
    hide() {
      this.isVisible.set(false);
    }
    toggle() {
      this.isVisible.set(!this.isVisible());
    }
    setItems(items) {
      this.items.set(items);
    }
    setLoading(loading) {
      this.isLoading.set(loading);
    }
    setReturnMode(returnMode) {
      this.returnMode.set(returnMode);
    }
    setAutomaticActivation(activation) {
      this.automaticActivation.set(activation);
    }
    activateItem(itemTitle) {
      this.items.set(this.items().map(item => {
        if (item.title === itemTitle) {
          item.active = true;
        } else {
          item.active = false;
        }
        return item;
      }));
    }
    findActiveItem() {
      const url = this.router.url.replace('/', '');
      this.items.set(this.items().map(item => {
        const itemRoute = item.route.replace('/', '');
        if (url.search(itemRoute) !== -1) {
          item.active = true;
        } else {
          item.active = false;
        }
        return item;
      }));
    }
    static {
      this.ɵfac = function NgxBottomNavigationService_Factory(t) {
        return new (t || NgxBottomNavigationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgxBottomNavigationService,
        factory: NgxBottomNavigationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgxBottomNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxBottomNavigationWrapperComponent = /*#__PURE__*/(() => {
  class NgxBottomNavigationWrapperComponent {
    constructor() {
      this.classes = input('');
      this.isVisible = signal(false);
      this.isLoading = signal(false);
      this.returnMode = signal(false);
      this.items = signal([]);
      this.bottomNavigationService = inject(NgxBottomNavigationService);
      this.StatusLightSizesEnum = StatusLightSizesEnum;
      this.StatusLightColorsEnum = StatusLightColorsEnum;
      this.StatusLightBordersEnum = StatusLightBordersEnum;
      effect(() => {
        this.isVisible.set(this.bottomNavigationService.isVisible());
      }, {
        allowSignalWrites: true
      });
      effect(() => {
        this.items.set(this.bottomNavigationService.items());
      }, {
        allowSignalWrites: true
      });
      effect(() => {
        this.isLoading.set(this.bottomNavigationService.isLoading());
      }, {
        allowSignalWrites: true
      });
      effect(() => {
        this.returnMode.set(this.bottomNavigationService.returnMode());
      }, {
        allowSignalWrites: true
      });
    }
    getBadgeType(badgeText) {
      return this.isNumber(badgeText) ? 'count' : 'text';
    }
    isNumber(value) {
      if (typeof value == 'number') return true;
      if (typeof value !== 'string') return false;
      return !isNaN(Number(value)) && !isNaN(parseFloat(value));
    }
    handleBack() {
      this.bottomNavigationService.backSubject.next();
    }
    static {
      this.ɵfac = function NgxBottomNavigationWrapperComponent_Factory(t) {
        return new (t || NgxBottomNavigationWrapperComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxBottomNavigationWrapperComponent,
        selectors: [["ngx-bottom-navigation-wrapper"]],
        inputs: {
          classes: [i0.ɵɵInputFlags.SignalBased, "classes"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 7,
        consts: [[3, "ngClass"], [1, "bottom-navigation-items", "d-flex", "align-items-center", "justify-content-space-between"], [1, "bottom-navigation-items-item", "cursor-pointer", "d-flex", "flex-column", "align-items-center", "justify-content-center", "gap-tiny", "pt-tiny", "pb-micro", "px-atom", "border-l-300", "border-color-tint"], [1, "bottom-navigation-items-item", "cursor-pointer", "d-flex", "flex-column", "align-items-center", "justify-content-center", "gap-tiny", "pt-tiny", "pb-micro", "px-atom", "border-l-300", "border-color-tint", 3, "click"], [1, "bottom-navigation-items-item-iconbox", "text-onback-high"], [3, "name", "iconSize", "type"], [1, "bottom-navigation-items-item-title", "text-onback-medium", "l-2"], ["ngxRouterLoading", "", 1, "bottom-navigation-items-item", "cursor-pointer", "d-flex", "flex-column", "align-items-center", "justify-content-center", "gap-tiny", "pt-tiny", "pb-micro", "px-atom", 3, "ngxTooltip", "tooltipPosition", "tooltipType", "routerLink", "ngClass"], [1, "bottom-navigation-items-item-badge"], [1, "bottom-navigation-items-item-iconbox", 3, "ngClass"], [1, "bottom-navigation-items-item-title", "l-2", 3, "ngClass"], [3, "size", "mode", "status", "type"], [1, "bottom-navigation-items-item-light"], [3, "isAbsolute", "showStatusLight", "statusSize", "statusColor", "statusBorderColor"], [3, "size", "status", "circularIcon", "type"], [3, "name", "type", "iconSize", "secondaryColor"], ["ngxRouterLoading", "", 1, "bottom-navigation-items-item", "cursor-pointer", "d-flex", "flex-column", "align-items-center", "justify-content-center", "gap-tiny", "pt-tiny", "pb-micro", "px-atom", 3, "routerLink", "ngClass"]],
        template: function NgxBottomNavigationWrapperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NgxBottomNavigationWrapperComponent_Conditional_1_Template, 1, 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("bottom-navigation py-low px-minus surface-glass-onback radius-giant elevation-dialog-blur ", ctx.classes(), "");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0, ctx.isVisible()));
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.isVisible() ? 1 : -1);
          }
        },
        dependencies: [NgClass, NgxIcon, NgxTooltipDirective, RouterLink, NgxBadgeModule, i1.NgxBadgeComponent, NgxStatusLightComponent, NgxRouterLoadingDirective],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.bottom-navigation[_ngcontent-%COMP%]{position:absolute;left:50%;right:50%;bottom:20px;height:64px;opacity:0;pointer-events:none;z-index:-1;transition:ease all .5s}.bottom-navigation.visible[_ngcontent-%COMP%]{left:20px;right:20px;opacity:1;pointer-events:all;z-index:999}.bottom-navigation-items-item[_ngcontent-%COMP%]{width:74px;height:52px;position:relative}.bottom-navigation-items-item-badge[_ngcontent-%COMP%]{position:absolute;top:0;left:15px}.bottom-navigation-items-item-light[_ngcontent-%COMP%]{position:absolute;left:25px!important;top:6px!important}.bottom-navigation-items-item.active[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:0;left:50%;transform:translate(-50%);width:8px;height:2px;background-color:var(--surface-brand);border-radius:10px}"]
      });
    }
  }
  return NgxBottomNavigationWrapperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgxBottomNavigationService, NgxBottomNavigationWrapperComponent };
